import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const adminApi = axios.create({ baseURL: API });
adminApi.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("autohq_admin_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

const CUSTOMER_TOKEN_KEY = "autohq_customer_token";

export const customerApi = axios.create({ baseURL: API });
customerApi.interceptors.request.use((cfg) => {
  const t = localStorage.getItem(CUSTOMER_TOKEN_KEY);
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export const setCustomerToken = (t) => {
  if (t) localStorage.setItem(CUSTOMER_TOKEN_KEY, t);
  else localStorage.removeItem(CUSTOMER_TOKEN_KEY);
};
export const getCustomerToken = () => localStorage.getItem(CUSTOMER_TOKEN_KEY);

export const loadRazorpayScript = () =>
  new Promise((resolve) => {
    if (window.Razorpay) return resolve(true);
    const s = document.createElement("script");
    s.src = "https://checkout.razorpay.com/v1/checkout.js";
    s.onload = () => resolve(true);
    s.onerror = () => resolve(false);
    document.body.appendChild(s);
  });

export const WHATSAPP_NUMBER = process.env.REACT_APP_WHATSAPP_NUMBER;
export const PHONE_DISPLAY = process.env.REACT_APP_PHONE_NUMBER;
export const INSTAGRAM_URL = process.env.REACT_APP_INSTAGRAM_URL;

export const waLink = (text) =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(text)}`;

export const CAR_BRANDS = [
  "Maruti Suzuki", "Hyundai", "Tata", "Honda", "Toyota", "Kia", "Mahindra", "Other",
];

export const SERVICES_NEEDED = [
  "Periodic Service", "AC Repair", "Denting & Painting", "Wheel Care",
  "Insurance Claim", "Battery & Brakes", "Wash & Detailing", "Other",
];

export const isValidPhone = (p) => /^[6-9]\d{9}$/.test(p);

export const errText = (e) => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => (x && x.msg) || "").filter(Boolean).join(" ");
  return "Something went wrong. Please try again.";
};

export const fmtDate = (iso) =>
  iso ? new Date(iso).toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" }) : "—";
